import { Navigate, Route, Routes } from 'react-router-dom';

import {
  ForgotPageContainer,
  LoginPageContainer,
  LogoutContainer,
  ResetContainer,
  SignupPageContainer,
  VerifyContainer,
} from 'apps/auth/scripts/containers';
import { CardContainer } from 'apps/card/scripts/containers';
import {
  BillingContainer,
  InvoiceContainer,
} from 'apps/dashboard/billing/scripts/containers';
import {
  CardCreateContainer,
  CardDeliveryContainer,
  CardDetailsContainer,
} from 'apps/dashboard/card/scripts/containers';
import { CardsContainer } from 'apps/dashboard/cards/scripts/containers';
import { CheckoutContainer } from 'apps/dashboard/checkout/scripts/containers';
import { SettingsContainer } from 'apps/dashboard/settings/scripts/containers';
import { SignedContainer } from 'apps/dashboard/signed/scripts/containers';
import { OnboardingContainer } from 'apps/onboarding/scripts/containers';
import { RequireAuth, RequireUnauth } from 'apps/shared/scripts/components';
import { NotFoundContainer } from 'apps/shared/scripts/containers';

const routes = (
  <Routes>
    <Route path="/">
      <Route path=":cardId" element={<CardContainer />} />
      <Route path="onboarding" element={<OnboardingContainer />} />
      <Route path="dashboard">
        <Route index element={<Navigate to="/dashboard/cards" replace />} />
        <Route
          path="create"
          element={
            <RequireAuth>
              <CardCreateContainer />
            </RequireAuth>
          }
        />
        <Route path="cards">
          <Route
            index
            element={
              <RequireAuth>
                <CardsContainer />
              </RequireAuth>
            }
          />
          <Route path=":cardId">
            <Route
              index
              element={
                <RequireAuth>
                  <CardDetailsContainer />
                </RequireAuth>
              }
            />
            <Route
              path="upgrade"
              element={
                <RequireAuth>
                  <CheckoutContainer />
                </RequireAuth>
              }
            />
            <Route
              path="delivery"
              element={
                <RequireAuth>
                  <CardDeliveryContainer />
                </RequireAuth>
              }
            />
          </Route>
        </Route>
        <Route path="billing">
          <Route
            index
            element={
              <RequireAuth>
                <BillingContainer />
              </RequireAuth>
            }
          />
          <Route path=":invoiceId">
            <Route
              index
              element={
                <RequireAuth>
                  <InvoiceContainer />
                </RequireAuth>
              }
            />
          </Route>
        </Route>
        <Route
          path="settings"
          element={
            <RequireAuth>
              <SettingsContainer />
            </RequireAuth>
          }
        />
        <Route path="signed">
          <Route
            index
            element={
              <RequireAuth>
                <SignedContainer />
              </RequireAuth>
            }
          />
        </Route>
      </Route>
      <Route
        path="login"
        element={
          <RequireUnauth>
            <LoginPageContainer />
          </RequireUnauth>
        }
      />
      <Route
        path="signup"
        element={
          <RequireUnauth>
            <SignupPageContainer />
          </RequireUnauth>
        }
      />
      <Route
        path="forgot"
        element={
          <RequireUnauth>
            <ForgotPageContainer />
          </RequireUnauth>
        }
      />
      <Route
        path="reset"
        element={
          <RequireUnauth>
            <ResetContainer />
          </RequireUnauth>
        }
      />
      <Route
        path="verify"
        element={
          <RequireAuth>
            <VerifyContainer />
          </RequireAuth>
        }
      />
      <Route path="logout" element={<LogoutContainer />}></Route>
      <Route path="*" element={<NotFoundContainer />} />
    </Route>
  </Routes>
);

export default routes;
